export const linkedInUrl = "https://www.linkedin.com/in/salmananza/";
export const gitHubUrl = "https://github.com/salanza";